export default function (type, data, callback, dataType = 'json', param = null, errorCallback = null, defaultHeaders = null) {
  const getCurrentUrl = new URL(window.location.href);
  var scrollToTheGameExecuted = false;
  var isAjaxLoading = false;

  // Attach an event handler for the start of an AJAX request
  $(document).ajaxStart(function() {
    isAjaxLoading = true;
    // You can perform additional actions when an AJAX request starts here
  });

  // Attach an event handler for the end of an AJAX request
  $(document).ajaxStop(function() {
    isAjaxLoading = false;
    // You can perform additional actions when an AJAX request stops here
  });

  function scrollToTheGame() {
    if (getCurrentUrl.pathname == '/') {
      var storedId  = JSON.parse(sessionStorage.getItem('id-game'));
      var targetElement = $('#' + storedId);
      if (targetElement.length > 0) {
        $('html, body').animate({
          scrollTop: targetElement.offset().top - 150
        }, 100);
      }
    }
  }

  const executeScrollToTheGame = () => {
    if (!isAjaxLoading) {
      if (!scrollToTheGameExecuted) {
        scrollToTheGameExecuted = true;
        if (sessionStorage.getItem('filTerms')) {
          setTimeout(scrollToTheGame, 100);
        }
      }
    }
  }

  const checkCookieExists = (cookieName) => {
    return document.cookie.split('; ').some(cookie => cookie.startsWith(cookieName + '='));
  }

  const removeAjaxLoader = () => {
    $('body, .overlay.loading, .overlay.user, .custom-loader').removeClass('active');
    $('.filtered-listing-games-wrapper').css('opacity', '');
  }
  
    // $('.custom-loader').addClass('active');
    // $('.filtered-listing-games-wrapper').css('opacity', '0.45')
    // $('body, .overlay, .custom-loader').css('opacity', '0.45');
  if (localStorage.getItem('showLoader') === 'false') {
    $('.custom-loader').addClass('active');
    $('.filtered-listing-games-wrapper').css('opacity', '0.45')
    localStorage.removeItem('showLoader')
  } else {
    if (!$('.overlay.user').hasClass('active')) {
      $('body, .overlay.loading, .custom-loader').addClass('active');
    }
  }

  if (defaultHeaders === null) {
    defaultHeaders = {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Accept': 'application/json',
    }
  }

  $.ajax({
    url: '/wp-admin/admin-ajax.php',
    type: typeof type !== 'undefined' ? type : 'GET',
    dataType: dataType,
    data: data,
    headers: defaultHeaders,
    beforeSend: function () {
      if (typeof window.request !== 'undefined') {
        window.request.abort();
      }
    },
    success: function (response) {
      if (response.redirect_url !== undefined) {
        if (response.file_name !== undefined) {
          removeAjaxLoader();
        } else {
          $(window).unload(function () {
            removeAjaxLoader();
          })
        }
      } else {
        const cookieExists = checkCookieExists('gamesCookieCount');
        if (getCurrentUrl.pathname == '/') {
          executeScrollToTheGame();
          if (cookieExists || sessionStorage.getItem('id-game') !== null) {
            setTimeout(function () {
              removeAjaxLoader();
            }, 1700);
          } else {
            removeAjaxLoader();
          }
        } else {
          removeAjaxLoader();
        }
      }

      if (callback) {
        callback(response, param)
      }
    },
    error: function (errorResponse) {
      $('body, .overlay.loading, .custom-loader').removeClass('active');
      if (errorCallback) {
        errorCallback(errorResponse)
      }
    },
  });
}



// WEBPACK FOOTER //
// ./scripts/exports/ajax.js